// TODO:リファクタlこのファイルapiService.tsに統合する
import { AxiosResponse } from 'axios';
import {
  getAdminContracts,
  postAdminContractConfirm,
  postAdminContractCancel,
} from '@/API/apiService';

/**
 * 新しいデータ構造に合わせた契約情報の型定義
 */
export interface Contract {
  contract_id: number;
  applicant_id: number;
  applicant_name: string;
  cancel_date: string | null;
  contract_status_id: number;
  contract_status_name: string;
  end_date: string;
  is_cancel: boolean;
  monthly_price: number;
  property_id: number;
  property_name: string;
  room_type_id: number;
  room_type_name: string;
  site_controller_book_id: string;
  start_date: string;
}

/**
 * 契約一覧を取得する関数
 */
export const fetchContracts = async (): Promise<Contract[]> => {
  try {
    const response: AxiosResponse<any> = await getAdminContracts();
    // API のレスポンスが { data: Contract[] } の形の場合
    const contracts: Contract[] = response.data.data ?? response.data;
    return contracts;
  } catch (error) {
    console.error('契約情報の取得に失敗しました:', error);
    return [];
  }
};

/**
 * 契約のステータスを「確定」に更新する関数
 */
export const confirmContract = async (
  contract_id: number | string
): Promise<Contract> => {
  try {
    const response: AxiosResponse<any> =
      await postAdminContractConfirm(contract_id);
    // 更新後の契約データが返される場合
    return response.data.data || response.data;
  } catch (error) {
    console.error('契約の確定に失敗しました:', error);
    throw error;
  }
};

/**
 * 契約をキャンセルする関数
 */
export const cancelContract = async (
  contract_id: number | string
): Promise<Contract> => {
  try {
    const response: AxiosResponse<any> =
      await postAdminContractCancel(contract_id);
    return response.data.data || response.data;
  } catch (error) {
    console.error('契約のキャンセルに失敗しました:', error);
    throw error;
  }
};
